// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"333f9c75","419":"b78927db","777":"03fec5a6"}[chunkId] + ".chunk.css";
};